import { createRouter, createWebHistory } from "vue-router";
import { isPWA } from '@/utils/isPwa'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes: [
    { path: '/', name: 'Landing', component: () => import('../components/AngerLanding.vue') },
    { path: '/avisoPrivacidad', name: 'avisoPrivacidad', component: () => import('../components/AngerAviso.vue') },
    { path: '/home', name: 'Home', component: () => import('../components/AngerHome.vue'), meta: { requiresAuth: true } },
    { path: '/homeplay', name: 'HomePlay', component: () => import('../components/AngerPlay.vue'), meta: { requiresAuth: true } },
    { path: '/anger', name: 'Ira', component: () => import('../components/AngerIra.vue'), meta: { requiresAuth: true } },
    { path: '/angerpulse', name: 'Angerpulse', component: () => import('../components/AngerWhat.vue'), meta: { requiresAuth: true } },
    { path: '/angerwho', name: 'Para quien', component: () => import('../components/AngerWho.vue'), meta: { requiresAuth: true } },
    { path: '/Comousarlo', name: 'Comousarlo', component: () => import('../components/AngerHow.vue'), meta: { requiresAuth: true } },
    { path: '/cuandousarlo', name: 'Cuandousarlo', component: () => import('../components/AngerWhen.vue'), meta: { requiresAuth: true } },
    { path: '/info', name: 'Informacion', component: () => import('../components/AngerInfo.vue'), meta: { requiresAuth: true } },
    { path: '/configuracion', name: 'Configuracion', component: () => import('../components/AngerConfig.vue'), meta: { requiresAuth: true } },
    { path: '/audioteca', name: 'Audioteca', component: () => import('../components/AngerAudioteca.vue'), meta: { requiresAuth: true } },
    { path: '/dashboard', name: 'Dashboard', component: () => import('../components/AngerDashboard.vue'), meta: { requiresAuth: true } },
    { path: '/perfil', name: 'Perfil', component: () => import('../components/AngerUser.vue'), meta: { requiresAuth: true } },
    { path: '/plan', name: 'Plan', component: () => import('../components/AngerTrial.vue'), meta: { requiresAuth: true } },
    { path: '/login', name: 'Login', component: () => import('../components/AngerLogin.vue') },
    { path: '/success', name: 'Success', component: () => import('../components/AngerSuccess.vue'), meta: { requiresAuth: true } },
    { path: '/cancel', name: 'Cancel', component: () => import('../components/AngerCancel.vue'), meta: { requiresAuth: true } },
    { path: '/prueba', name: 'Prueba', component: () => import('../components/AngerPrueba.vue') },
    { path: '/account', name: 'Account', component: () => import('../components/AngerAccount.vue') },
    { path: '/verify', name: 'Verify', component: () => import('../components/AngerVerifyCode.vue') },
    { path: '/configuracion-guia', name: 'ConfiguracionGuia', component: () => import('../components/GuiaConfig.vue'), meta: { requiresAuth: true } },
    { path: '/audioteca-guia', name: 'AudiotecaGuia', component: () => import('../components/GuiaAudioteca.vue'), meta: { requiresAuth: true } },
    { path: '/dashboard-guia', name: 'DashboardGuia', component: () => import('../components/GuiaDashboard.vue'), meta: { requiresAuth: true } },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return savedPosition || { top: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const isAuthenticated = token !== null && token !== '' && token !== 'undefined'

  const pwa = isPWA()


  if (!pwa && to.path !== '/' && to.path !== '/avisoPrivacidad') {
    return next('/')
  }

  // 🔐 Rutas protegidas
  if (to.meta.requiresAuth && !isAuthenticated) {
    return next('/login')
  }

  // 🔁 Si ya está logueado y va a login
  if (to.path === '/login' && isAuthenticated) {
    return next('/home')
  }

  next()
})


// router.beforeEach((to, from, next) => {
//   const isAuthenticated = localStorage.getItem('token') // o revisa tu store/pinia
//   console.log(isAuthenticated);
//   if (to.meta.requiresAuth && !isAuthenticated) {
//     next('/login') // si no está logueado → login
//   } else if (to.path === '/login' && isAuthenticated) {
//     next('/home') // si ya está logueado → home
//   } else {
//     next()
//   }
// })

export default router;
